import { createReducer, on } from '@ngrx/store';
import * as AppActions from '../actions/app.action';
import { AppState } from '@app/types/app.types';

export const initialState: AppState = {
  filters: null,
  voidFilters: null,
  voidAppliedFilters: null,
  voidFilterPayload: null,
  hardFilters: null,
  azureAccessToken: null,
  azureIdToken: null,
  profile: null,
  selectedSKUs: [],
  prefFilters: null,
  screenAccessState: [],
  voidBatchDate: null,
  recsBatchDate: null,
};

// Define the reducer to handle actions
export const appReducer = createReducer(
  initialState,
  on(AppActions.setHardFilters, (state, payload: any) => ({
    ...state,
    hardFilters: payload?.hardFilters || [], // Destructure filters from action payload and update state
  })),
  on(AppActions.setFilters, (state, payload: any) => ({
    ...state,
    filters: payload?.filters || null, // Destructure filters from action payload and update state
  })),
  on(AppActions.setVoidFilters, (state, payload: any) => ({
    ...state,
    voidFilters: payload?.filters || null, // Destructure filters from action payload and update state
  })),
  on(AppActions.setVoidFilters, (state, payload: any) => ({
    ...state,
    voidFilters: payload?.filters || null, // Destructure filters from action payload and update state
  })),
  on(AppActions.setAzureAccessToken, (state, payload: any) => ({
    ...state,
    azureAccessToken: payload?.accessToken || null, // Destructure filters from action payload and update state
    azureIdToken: payload?.idToken || null, // Destructure filters from action payload and update state
  })),
  on(AppActions.setProfile, (state, payload: any) => ({
    ...state,
    profile: payload?.profile || null, // Destructure filters from action payload and update state
  })),
  on(AppActions.setVoidAppliedFilters, (state, payload: any) => ({
    ...state,
    voidAppliedFilters: payload.filters || null, // Destructure filters from action payload and update state
  })),
  on(AppActions.setVoidFilterPayload, (state, payload: any) => ({
    ...state,
    voidFilterPayload: payload.voidFilterPayload || null,
  })),
  on(AppActions.resetVoidFilterPayload, (state) => ({
    ...state,
    voidFilterPayload: null,
  })),
  on(AppActions.resetVoidAppliedFilters, (state) => ({
    ...state,
    voidAppliedFilters: null,
  })),
  on(AppActions.selectSKU, (state, { sku }) => {
    const newSelectedSKU = state.selectedSKUs?.includes(sku) ? [...state.selectedSKUs] : [...state.selectedSKUs, sku];
    return { ...state, selectedSKUs: newSelectedSKU };
  }),
  on(AppActions.deselectSKU, (state, { sku }) => ({
    ...state,
    selectedSKUs: state.selectedSKUs.filter((s) => s !== sku),
  })),
  on(AppActions.clearSelectedSKU, (state) => ({
    ...state,
    selectedSKUs: [],
  })),
  on(AppActions.prefFilters, (state, payload: any) => ({
    ...state,
    prefFilters: payload?.prefFilters || null, // Destructure filters from action payload and update state
  })),
  on(AppActions.setScreenAccess, (state, { screenAccessState }) => {
    console.log('NGRX Reducer: setScreenAccess received. New screenAccessState:', screenAccessState); // ADD THIS
    return {
      ...state,
      screenAccessState: screenAccessState || [],
    };
  }),
  on(AppActions.setRecsBatchDate, (state, { recsBatchDate }) => {
    return {
      ...state,
      recsBatchDate: recsBatchDate || null,
    };
  }),
  on(AppActions.setVoidBatchDate, (state, { voidBatchDate }) => {
    return {
      ...state,
      voidBatchDate: voidBatchDate || null,
    };
  }),
);
